import * as DAOUtils from "../utils/DAOUtils";

export function getAddresses() {
  return DAOUtils.get("/orders/deliveryAddresses");
}

export function createAddress(address) {
  return DAOUtils.post("/orders/deliveryAddresses", address);
}

export function updateAddress(address) {
  return DAOUtils.put("/orders/deliveryAddresses", address);
}

export function deleteAddress(addressId) {
  return DAOUtils.remove(`/orders/deliveryAddresses/${addressId}`);
}
